import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Vault } from "lucide-react";
import { api } from "@/lib/api";
import { formatIsoDay } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

// v1.38.0 Banka kasasında vadesi yaklaşan / geçmiş evrak
export default function VaultDueCard() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [s, setS] = useState(null);
  const ok = can("cek_senet");
  useEffect(() => { if (ok) api.get("/cek-senet/vault-due").then(({ data }) => setS(data)).catch(() => {}); }, [ok]);
  if (!s || !s.enabled || !s.count) return null;
  const red = s.overdue_count > 0;
  return (
    <button onClick={() => nav("/cek-senet?konum=banka_kasasi&due_soon=1")} data-testid="dashboard-vault-due-card"
      className={`w-full mb-4 flex items-center gap-3 rounded-lg border px-4 py-3 text-left transition-colors ${red ? "border-rose-300 bg-rose-50 hover:bg-rose-100" : "border-amber-300 bg-amber-50 hover:bg-amber-100"}`}>
      <Vault className={`h-5 w-5 ${red ? "text-rose-700" : "text-amber-700"}`} />
      <div>
        <div className={`font-semibold text-sm ${red ? "text-rose-900" : "text-amber-900"}`}>Banka Kasasında Vadesi Yaklaşan Evraklar · <span data-testid="vault-due-count">{s.count}</span>
          {red && <span className="ml-2 rounded bg-rose-600 px-1.5 py-0.5 text-[11px] text-white" data-testid="vault-due-overdue">{s.overdue_count} vadesi geçmiş</span>}</div>
        <div className="text-[12px] text-slate-700" data-testid="vault-due-summary">{Object.entries(s.by_currency).map(([c, v]) => `${v.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ${c}`).join(" · ")} · en yakın vade {formatIsoDay(s.nearest_due)} · {s.days} gün içinde kasadan alıp tahsile verin</div>
      </div>
    </button>
  );
}
